import { GET_LENDER_PERFORMANCE_FUNNEL } from './getLenderPerformanceFunnel';
import { GET_LENDER_PERFORMANCE_RATIO_CARDS } from './getLenderPerformanceRatioCards';
import { GET_LENDER_PERFORMANCE_CONVERSION_TABLE } from './getLenderPerformanceConversionTable';
import { GET_LENDER_PERFORMANCE_TREND } from './getLenderPerformanceTrend';
import { GET_LENDER_PERFORMANCE_TREND_BY_LENDER } from './getLenderPerformanceTrendByLender';
import { GET_LENDER_APPROVAL_TERMS_SUMMARY } from './getLenderApprovalTermsSummary';
import { GET_LENDER_TERMS_COMPARISON_TABLE } from './getLenderTermsComparisonTable';
import { GET_LENDER_AVERAGE_RATE_BY_LENDER } from './getLenderAverageRateByLender';
import { GET_LENDER_TERM_DISTRIBUTION_BY_LENDER } from './getLenderTermDistributionByLender';
import { GET_LENDER_TOTAL_COST_COMPARISON } from './getLenderTotalCostComparison';
import { GET_LOCATIONS } from './getLocations';

export const reportsApi = {
  getLenderPerformanceFunnel: GET_LENDER_PERFORMANCE_FUNNEL,
  getLenderPerformanceRatioCards: GET_LENDER_PERFORMANCE_RATIO_CARDS,
  getLenderPerformanceConversionTable: GET_LENDER_PERFORMANCE_CONVERSION_TABLE,
  getLenderPerformanceTrend: GET_LENDER_PERFORMANCE_TREND,
  getLenderPerformanceTrendByLender: GET_LENDER_PERFORMANCE_TREND_BY_LENDER,
  getLenderApprovalTermsSummary: GET_LENDER_APPROVAL_TERMS_SUMMARY,
  getLenderTermsComparisonTable: GET_LENDER_TERMS_COMPARISON_TABLE,
  getLenderAverageRateByLender: GET_LENDER_AVERAGE_RATE_BY_LENDER,
  getLenderTermDistributionByLender: GET_LENDER_TERM_DISTRIBUTION_BY_LENDER,
  getLenderTotalCostComparison: GET_LENDER_TOTAL_COST_COMPARISON,
  getLocations: GET_LOCATIONS,
};
